/**
 * `Task` read/write shapes — mirrors the backend contract
 * (backend/.../module/task/api/dto/{TaskView,CreateTaskRequest,UpdateTaskRequest,
 * TransitionTaskStatusRequest}.java).
 */

export const TASK_STATUSES = ['todo', 'in_progress', 'blocked', 'done'] as const
export type TaskStatus = (typeof TASK_STATUSES)[number]

export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  todo: 'To do',
  in_progress: 'In progress',
  blocked: 'Blocked',
  done: 'Done',
}

export const TASK_PRIORITIES = ['low', 'medium', 'high'] as const
export type TaskPriority = (typeof TASK_PRIORITIES)[number]

export const TASK_PRIORITY_LABEL: Record<TaskPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
}

export interface TaskView {
  id: string
  /** `null` for a general work-queue item not linked to any Case. */
  caseId: string | null
  title: string
  description: string | null
  status: TaskStatus
  priority: TaskPriority
  /** A bare id — `module.identity` exposes no user-directory list endpoint yet (disclosed gap). */
  assigneeUserId: string | null
  /** ISO `yyyy-MM-dd`, or `null`. */
  dueDate: string | null
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  version: number
}

export interface CreateTaskRequest {
  caseId?: string | null
  title: string
  description?: string | null
  priority?: TaskPriority | null
  assigneeUserId?: string | null
  dueDate?: string | null
}

/** `PATCH /tasks/{id}` — a full replace of the mutable field set, never `status`. */
export interface UpdateTaskRequest {
  title: string
  description?: string | null
  priority?: TaskPriority | null
  assigneeUserId?: string | null
  dueDate?: string | null
}
